module.exports = __webpack_public_path__ + "81b193c70b1867f2213ac6f792fee340.png";